import { VstoOffice } from "../vsto/VstoOffice";

function InitOffice() {
  const urlParams = new URLSearchParams(window.location.search);
  const hostInfo = urlParams.get("_host_Info");

  if (hostInfo?.toLowerCase() == "vsto-plugin") {
    return new VstoOffice();
  }

  return window.Office;
}
export const Office = InitOffice();
